// ─── The shift band (z8nrz7fbcj) ─────────────────────────────────────────────
// Where "now" sits inside the shift being looked at. Pure, so the rules are
// unit-tested (vitest here runs `.ts` only).

export type ShiftPhase = 'upcoming' | 'live' | 'ended'

export interface ShiftProgress {
  phase: ShiftPhase
  /** 0–100: how far through the shift now is (0 before it, 100 after it). */
  percent: number
  /** "5 h 12 m left", "Starts in 2 h", "Ended 40 m ago". */
  label: string
}

/** "5 h 12 m", "2 h", "40 m", "under a minute". */
export function formatSpan(ms: number): string {
  const minutes = Math.floor(ms / 60_000)
  if (minutes < 1) return 'under a minute'
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m} m`
  return m === 0 ? `${h} h` : `${h} h ${m} m`
}

export function shiftProgress(fromIso: string, toIso: string, now: Date): ShiftProgress {
  const from = new Date(fromIso).getTime()
  const to = new Date(toIso).getTime()
  const t = now.getTime()
  if (!(to > from) || Number.isNaN(from) || Number.isNaN(to)) return { phase: 'ended', percent: 100, label: '' }
  if (t < from) return { phase: 'upcoming', percent: 0, label: `Starts in ${formatSpan(from - t)}` }
  if (t >= to) return { phase: 'ended', percent: 100, label: `Ended ${formatSpan(t - to)} ago` }
  return {
    phase: 'live',
    percent: Math.round(((t - from) / (to - from)) * 1000) / 10,
    label: `${formatSpan(to - t)} left`,
  }
}

/** "07:00" in the viewer's clock, for the ends of the band. */
export function clockTime(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
}
